import React from 'react';
// import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './SubscriptionTabs.less';

function SubscriptionTabs({ currentTab }) {
  const tabs = {
    features: { label: 'Features', path: '/subscriptions/features' },
    manage: { label: 'Manage Subscriptions', path: '/subscriptions' },
    payment: { label: 'Payment Details', path: '/subscriptions/payment' }
  };

  return (
    <div className='subscription-tabs tabs'>
      {Object.keys(tabs).map(key => (
        <Link
          key={key}
          to={tabs[key].path}
          className={currentTab === key ? 'active' : ''}
        >
          {tabs[key].label}
        </Link>
      ))}
    </div>
  );
}

SubscriptionTabs.propTypes = {};
SubscriptionTabs.defaultProps = {
  currentTab: 'manage'
};
SubscriptionTabs.displayName = 'SubscriptionTabs';

export default SubscriptionTabs;
